<template>
  <!-- 空白的编辑器 -->

  <div class="editor-area">
    <!-- element upload -->

    <!-- 内容标题 -->
    <div class="input-title-area">
      <el-input class="artical-title"
                type="text"
                maxlength="30"
                @change="contentTitleChange"
                show-word-limit
                placeholder="请输入标题..."
                v-model="content_title">
      </el-input>
    </div>
    <!-- 编辑器 -->
    <div class="editor-v2-artical">
      <quill-editor v-model="content"
                    ref="myQuillEditor"
                    :options="editorOption"
                    @input="modelContent"
                    @change="onEditorChange($event)"
                    @blur="onEditorBlur($event)"
                    @focus="onEditorFocus($event)"
                    @ready="onEditorReady($event)"></quill-editor>
    </div>
    <!-- 分割线 -->
    <div v-if="showUnderLine"
         style="width: 87%; margin: 0 auto">
      <el-divider></el-divider>
    </div>
    <!-- 插槽 -->
    <div class="editor-area-addition">
      <!-- 附加项插槽 -->
      <slot name="addition"> </slot>
    </div>
    <div v-if="showUnderLine"
         style="width: 87%; margin: 0 auto">
      <el-divider></el-divider>
    </div>
    <!-- 按钮插槽 -->
    <div class="editor-area-button">
      <!-- 附加项插槽 -->
      <slot name="button"> </slot>
    </div>
  </div>
</template>

<script>
// 修改 对其方式 ，quill 提供三种对其方式：1，style 2.class 3.ql-class
let Align = Quill.import('attributors/style/align')
Align.whitelist = ['right', 'center', 'justify']
Quill.register(Align, true)

let Size = Quill.import('attributors/style/size')
Size.whitelist = [
  '9px',
  '10px',
  false,
  '12px',
  '13px',
  '14px',
  '15px',
  '16px',
  '17px',
  '18px',
  '19px',
  '20px',
]
Quill.register(Size, true)

const container = [
  // false： 就是默认选项
  // 撤销 重做
  // ["revoke"],
  // ["restore"],
  // 清楚格式，格式刷
  ['clean'],
  // 标题
  [{ header: [1, 2, 3, 4, false] }],
  // [{ header: 1 }, { header: 2 }],
  // 字体  false == false
  [{ font: [false, 'serif', 'monospace'] }],
  // 字号  列表中存在的代表所使用的字体
  // false代表的默认选中的字体大小,默认选中的18px。
  [
    {
      size: [
        '9px',
        '10px',
        false,
        '12px',
        '13px',
        '14px',
        '15px',
        '16px',
        '17px',
        '18px',
        '19px',
        '20px',
      ],
    },
  ],
  // 字体样式:加粗，斜体，下划线，划线
  ['bold', 'italic', 'underline', 'strike'],
  // 字体颜色， 背景色
  [{ color: [] }, { background: [] }],
  // 有序列表 无序列表
  [{ list: 'ordered' }, { list: 'bullet' }],
  // 任务✅
  // 对齐方式
  [{ align: ['right', 'center', 'justify'] }],
  // 左锁进，右锁进
  [{ indent: '-1' }, { indent: '+1' }],
  // 行距
  // 插入：视频、图片、音频、表格等
  ['image'],
  // ["link", "image", "video"],

  // 注释（引用）、 代码块
  // ["blockquote", "code-block"],
  // 上标，下标
  // [{ script: "sub" }, { script: "super" }],
  // 文字方向
  // [{ direction: "rtl" }],
]

// import { quillEditor, Quill } from 'vue-quill-editor'
// 不需要再次倒入了，因为字main中创建了对象

import {
  // container,
  // container 在 node module中
  ImageExtend,
  QuillWatch,
} from 'quill-image-super-solution-module'

import imageResize from 'quill-image-resize-module'
Quill.register('modules/ImageExtend', ImageExtend)
Quill.register('modules/ImageResize', imageResize)

export default {
  name: 'editor-artical',
  // components: { quillEditor },
  data() {
    return {
      content_title: this.content_title_prop,
      content: this.editor_content, // 富文本内容
      quillUpdateImg: false,
      editorOption: {
        // 覆盖编辑器的 配置项
        placeholder: '',
        theme: this.selectTheme, // or 'bubble'
        modules: {
          ImageResize: {},
          ImageExtend: {
            loading: true, // 是否显示加载信息
            name: 'image',
            size: 10, // 可选参数 图片大小，单位为M，1M = 1024kb
            action: this.upLoadImgAddress,
            accept:
              'image/jpg, image/png, image/gif, image/jpeg, image/bmp, image/x-icon',
            response: (res) => {
              // console.log(this.upLoadImgAddress)
              if (this.upLoadImgAddress == '') {
                this.$message({
                  message: '请添加上传图片的接口',
                })
                return
              }

              if (res.errno == '0') {
                return res.data.image_url
              } else {
                this.$message({
                  message: res.errmsg,
                  type: 'error',
                })
              }
            },
          },
          toolbar: {
            container: container, // 配置工具栏
            handlers: {
              image: function () {
                QuillWatch.emit(this.quill.id)
              },
            },
          },
        },
      },
    }
  },
  props: {
    index: null,
    upLoadImgAddress: {
      type: String,
      default: '',
    },
    showUnderLine: {
      // 文章底部分割线
      type: Boolean,
      default: false,
    },
    content_title_prop: {
      type: String,
      default: '',
    },
    // 传过来的内容
    editor_content: {
      type: String,
      default: '',
    },
    // 编辑器工具栏是否吸顶：0不吸顶， 其他数字代表滚动到某个值时吸顶。也可以通过样式直接吸顶
    stickToolbar: {
      type: Number,
      default: 0,
    },
    // 自定义属性:编辑器主题
    selectTheme: {
      type: String,
      default: 'snow',
      // bubble\snow
    },
  },
  created() {
    // 图标
    this.editorOption.initButton = function () {
      // 在使用的页面中初始化按钮样式
      const revokeButton = document.querySelector('.ql-revoke')
      revokeButton.style.cssText = 'width:28px;height:24px;padding:2px 4px'
      revokeButton.innerHTML =
        '<img style="width:18.4px;height:18.4px" src="' + +'" />'

      const restoreButton = document.querySelector('.ql-restore')
      restoreButton.parentNode.style.cssText = 'float:right;margin-right:0'
      restoreButton.style.cssText =
        'height:24px;color:#3B80FC;cursor:pointer;width:80px;text-align:center;'
      restoreButton.innerHTML = '一键恢复'
    }
  },
  mounted() {
    this.editorOption.initButton && this.editorOption.initButton()
  },
  mounted() {
    // 监听滚动事件 ：scroll  一旦滚动传递给 方法：this.handleScroll  不需要加（）
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 标题内容改变
    contentTitleChange(title) {
      this.$emit('title_change', title)
    },
    // 编辑器内容改变
    modelContent(content) {
      // console.log("文本框有变化");
      // console.log(this.introduce);
      // console.log(content);
      this.$emit('content_change', content)
      // this.introduce = event.traget.value;
    },
    // ------滚动吸顶------
    handleScroll(e) {
      // 得到页面滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop

      // 【1】
      // console.log('页面滚动所在的位置：')
      // console.log(scrollTop);
      // 【2】
      // console.log("传入的要求距离：");
      // console.log(this.stickToolbar);

      // 获取当前index
      // let obj = document.getElementsByClassName('editor-area')
      // console.log(obj)
      // 编辑器的工具栏
      let toolbar_obj = document.getElementsByClassName('ql-toolbar')
      // let toolbar_obj = document.querySelectorAll(".ql-toolbar,.ql-snow");
      let content_obj = document.getElementsByClassName('editor-area')
      // 指定组件
      let toolbar_item = toolbar_obj[this.index]
      let content_item = content_obj[this.index]
      // 【3】整个编辑器的 宽度
      // console.log("编辑器的宽度:");
      // console.log(content_obj[0].offsetWidth);
      // 注意：js 获取不到 css的样式，所以，content_obj[0].style.width 只能获取写在html里的宽度。

      // 【4】编辑器工具栏的文档对象：
      // console.log("编辑器工具栏的文档对象：");
      // console.log(toolbar_obj)

      // 【5】工具栏宽度
      // console.log("编辑器工具栏的宽度：");
      // console.log(toolbar_obj[0].offsetWidth);

      // console.log(this.stickToolbar); // 判断父组件 是否要求 编辑器工具栏吸顶
      if (toolbar_obj.length !== 0) {
        // 获取到了 工具栏的文档结构
        if (this.stickToolbar == 0) {
          // console.log("prop 要求，不需要执行滚动置顶");
        } else if (scrollTop > this.stickToolbar) {
          // console.log("prop 要求：需要吸顶：页面滚动的距离 大于设定的距离");
          if (toolbar_item.length !== 0) {
            // 浮动到最上面
            toolbar_item.style.zIndex = '100'
            // fixed 工具栏
            toolbar_item.style.position = 'fixed'
            // 让工具栏的宽度 == editor-area 的宽度
            toolbar_item.style.width = content_item.offsetWidth + 'px'

            // 距离顶部 为 0
            toolbar_item.style.top = '0'
          }
        } else if (scrollTop < this.stickToolbar) {
          if (toolbar_item.length !== 0) {
            // 改变style：
            toolbar_item.style.position = ''
            toolbar_item.style.width = ''
            toolbar_item.style.zIndex = ''
            toolbar_item.style.top = ''
          }
        }
      }
    },
    // ------编辑器自身事件------
    onEditorChange(value) {
      // console.log("change:监听内容编号");
      // console.log(value);
    },
    onEditorBlur(value) {
      // console.log("blur:失去光标");
      // console.log(value);
    },
    onEditorFocus(value) {
      // console.log("focus:出现光标");
      // console.log(value);
    },
    onEditorReady(value) {
      // console.log('ready:')
    },
  },
}
</script>

<style >
.editor-v2-artical {
  min-height: 500px;
}
/* 编辑器内容默认字体大小 及辅助样式 */
.ql-container {
  /* font-size: 1.167em; */
  font-size: 11pt;
}

/* --------- */
/*  编辑器样式 */
.artical-title {
  width: 90%;
  font-size: 20px;
}
.editor-v2-artical.ql-editor {
  /* 输入框真实高度 */
  /* background-color: blue; */
  /* border: 10px solid rgb(255, 255, 255); */
  height: 500px;
  padding: 10px 0px 20px;
  /* height: 200px; */
  line-height: 1.7;
}

.quill-editor .ql-toolbar {
  /* 工具栏样式 */
  width: 87%;
  margin: auto;
  background-color: white;
  border: 1px solid rgb(247, 245, 245);
  box-shadow: 2px 2px 5px 0.05px #cecccc;
}
/* .editor-v2-artical .ql-container {
  background-color: lightgreen;
} */
.quill-editor .ql-container {
  /* 输入框样式 */
  width: 87%;
  margin: auto;
  /* border: 1px solid rgb(247, 245, 245); */
  border: none;
  /* box-shadow: 2px 2px 5px 0.05px #cecccc; */
}
/* ---------- */
/* 编辑器外框 */
.editor-area {
  padding: 50px 0px 20px;
  border: 1px solid rgb(247, 245, 245);
  box-shadow: 2px 2px 5px 0.05px #cecccc;
  margin: 30px 50px;
}
/* 利用穿透，设置input边框隐藏 */
.input-title-area .el-input__inner {
  border: none;
  /* width: 82%; */
}
.input-title-area {
  padding: 20px 0;
  text-align: center;
}
/* 插槽 */
.editor-area-addition {
  padding: 0px 0px 20px;
  width: 87%;
  margin: auto;
}

.editor-area-button {
  padding: 20px 0px 20px;
  width: 87%;
  margin: auto;
}
</style>